"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CustomerCard;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _image = require("@site/pattern-library-core/image");
var _merchButton = require("@site/pattern-library-core/merch-button");
var _text = _interopRequireDefault(require("@ux/text"));
var _attribution = _interopRequireDefault(require("../attribution"));
/**
 * Local Imports
 */

const Container = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Container",
  class: "pl-c1a1fm8t"
});
const ProductListContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ProductListContainer",
  class: "pl-pnt0mb9"
});
const BottomContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "BottomContainer",
  class: "pl-b1eh5nbf"
});
const ImgContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ImgContainer",
  class: "pl-iomvpji"
});
const HeadlineWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "HeadlineWrapper",
  class: "pl-hnp0c7q"
});
const CustomerCardContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CustomerCardContainer",
  class: "pl-c12vkk33"
});
const List = /*#__PURE__*/(0, _react2.styled)("ul")({
  name: "List",
  class: "pl-lzbio1t"
});
const ProductListItem = /*#__PURE__*/(0, _react2.styled)("li")({
  name: "ProductListItem",
  class: "pl-p9fhfh9"
});
const IconContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "IconContainer",
  class: "pl-i1bs4acv"
});
const LinkContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "LinkContainer",
  class: "pl-l90aae1"
});
const AttributionBlock = /*#__PURE__*/(0, _react2.styled)("figcaption")({
  name: "AttributionBlock",
  class: "pl-a77z7pd"
});
function customFormatAttribution(rawAttribution, boldLineN) {
  if (!rawAttribution) return null;
  const lines = rawAttribution?.trim().split('\n').map(line => line.replace(/<\/?p>/g, ''));
  return /*#__PURE__*/_react.default.createElement("ul", {
    style: {
      listStyleType: 'none',
      padding: 0,
      margin: 0
    }
  }, lines.map((line, index) => {
    const isBold = line.match(/[a-zA-Z0-9]+\.[a-zA-Z0-9]/) || index === boldLineN - 1;
    return /*#__PURE__*/_react.default.createElement("li", {
      key: index,
      style: {
        fontWeight: isBold ? 'bold' : 'normal',
        padding: 0,
        margin: 0
      }
    }, line);
  }));
}

/**
 * Render Customer Card Component
 *
 * @param {Object} props React props
 * @param {String} props.cardHeading Card Heading
 * @param {String} props.cardAttribution Mobile background image
 * @param {Array} props.productList Desktop background image,
 * @param {String} props.partial Theme partial
 * @param {Boolean} props.invert Desktop background image,
 * @param {Object} props.cardImage Tablet portrait background image
 * @param {String} props.attribution Background Image Attribution
 * @param {String} props.attributionPartial Theme partial for attribution figcaption
 * @param {Boolean} props.attributionInvert Theme partial for attribution figcaption
 * @returns {React.ReactElement} Customer Card Component
 * @public
 */
function CustomerCard({
  cardHeading,
  cardAttribution,
  cardAttributionHeadline,
  cardAttributionDescription,
  productList,
  partial,
  invert,
  cardImage,
  attribution,
  attributionHeadline,
  attributionDescription,
  attributionPartial,
  attributionInvert
}) {
  const {
    url,
    altText,
    width,
    height
  } = cardImage;
  return /*#__PURE__*/_react.default.createElement(CustomerCardContainer, {
    padding: "none",
    "data-cy": "customer-card",
    "data-partial": partial || (invert ? 'dark1' : '')
  }, (attribution || attributionHeadline || attributionDescription) && /*#__PURE__*/_react.default.createElement(AttributionBlock, {
    "data-cy": "attribution",
    "data-partial": attributionPartial || (attributionInvert ? 'dark1' : '')
  }, /*#__PURE__*/_react.default.createElement(_attribution.default, {
    attribution: attribution,
    attributionHeadline: attributionHeadline,
    attributionDescription: attributionDescription,
    formatLegacy: () => (0, _patternLibraryUtils.formatAttribution)(attribution, true),
    fontWeight: "initial"
  })), /*#__PURE__*/_react.default.createElement(HeadlineWrapper, null, cardHeading && /*#__PURE__*/_react.default.createElement(_text.default.h2, {
    "data-cy": "headline-string",
    as: "heading",
    text: cardHeading
  })), /*#__PURE__*/_react.default.createElement(Container, {
    elementType: "section"
  }, /*#__PURE__*/_react.default.createElement(ProductListContainer, null, /*#__PURE__*/_react.default.createElement(BottomContainer, null, (cardAttribution || cardAttributionHeadline || cardAttributionDescription) && /*#__PURE__*/_react.default.createElement("div", {
    className: "card-attribution"
  }, /*#__PURE__*/_react.default.createElement(_attribution.default, {
    attribution: cardAttribution,
    attributionHeadline: cardAttributionHeadline,
    attributionDescription: cardAttributionDescription,
    formatLegacy: () => customFormatAttribution(cardAttribution, 2),
    fontWeight: "bold"
  })), /*#__PURE__*/_react.default.createElement(List, {
    "data-cy": "product-list"
  }, productList?.slice(0, 6).map((item, i) => {
    const {
      href,
      text,
      icon,
      _name,
      id
    } = item;
    return /*#__PURE__*/_react.default.createElement(ProductListItem, {
      key: i
    }, icon && /*#__PURE__*/_react.default.createElement(IconContainer, {
      "data-partial": "highlight-primary",
      "data-cy": "product-list-icon"
    }, /*#__PURE__*/_react.default.createElement(_patternLibraryUtils.Icon, {
      name: icon
    })), text && /*#__PURE__*/_react.default.createElement(LinkContainer, null, /*#__PURE__*/_react.default.createElement(_merchButton.NSMerchButton, {
      id: id,
      _name: _name,
      text: text,
      design: "inline",
      size: "small",
      href: href,
      ariaLabel: `${text}-button`
    })));
  }))), /*#__PURE__*/_react.default.createElement(ImgContainer, null, url && /*#__PURE__*/_react.default.createElement(_image.LazyPicture, {
    dataCy: "card-image",
    defaultSrc: url,
    defaultAltText: altText,
    width: width,
    height: height
  })))));
}
CustomerCard.propTypes = {
  cardHeading: _propTypes.default.string,
  cardAttribution: _propTypes.default.string,
  cardAttributionHeadline: _propTypes.default.string,
  cardAttributionDescription: _propTypes.default.string,
  productList: _propTypes.default.array,
  partial: _propTypes.default.string,
  invert: _propTypes.default.bool,
  cardImage: _propTypes.default.object,
  attribution: _propTypes.default.string,
  attributionHeadline: _propTypes.default.string,
  attributionDescription: _propTypes.default.string,
  attributionPartial: _propTypes.default.string,
  attributionInvert: _propTypes.default.bool
};